(function () {
  'use strict';
  const T = window.theme || { strings: {}, routes: {} };

  /* ---------- Header: shadow on scroll + drawer offset ---------- */
  const header = document.querySelector('[data-header]');
  const setHeaderOffset = () => {
    if (!header) return;
    const r = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-bottom', Math.max(r.bottom, 0) + 'px');
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  };
  setHeaderOffset();
  window.addEventListener('scroll', setHeaderOffset, { passive: true });
  window.addEventListener('resize', setHeaderOffset);
  const drawer = document.querySelector('[data-drawer]');
  if (drawer) {
    drawer.addEventListener('toggle', () => {
      setHeaderOffset();
      document.body.style.overflow = drawer.open ? 'hidden' : '';
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.open) drawer.open = false; });
  }

  /* ---------- Carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach((root) => {
    const track = root.querySelector('[data-carousel-track]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track) return;
    const step = () => {
      const slide = track.querySelector('.carousel__slide');
      return slide ? (slide.getBoundingClientRect().width + 16) * 2 : track.clientWidth * 0.8;
    };
    const update = () => {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Card swatches ---------- */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-swatch]');
    if (!sw) return;
    const card = sw.closest('[data-product-card]');
    if (!card) return;
    card.querySelectorAll('[data-swatch]').forEach((s) => s.classList.toggle('is-active', s === sw));
    const input = card.querySelector('[data-variant-input]');
    const btn = card.querySelector('[data-add-button]');
    if (input && sw.dataset.variantId) input.value = sw.dataset.variantId;
    if (btn) {
      const ok = sw.dataset.available === 'true';
      btn.disabled = !ok;
      btn.textContent = ok ? T.strings.addToCart : T.strings.soldOut;
    }
    const img = card.querySelector('[data-card-img]');
    if (img && sw.dataset.img) { img.removeAttribute('srcset'); img.src = sw.dataset.img; }
  });

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input[type=number]');
    if (!input) return;
    const min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart page: auto-update quantities ---------- */
  let cartTimer;
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-cart-qty]')) return;
    const input = e.target;
    const line = input.closest('[data-line]');
    clearTimeout(cartTimer);
    cartTimer = setTimeout(() => {
      if (!line) { input.form.submit(); return; }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line.dataset.line, 10), quantity: parseInt(input.value, 10) || 0 })
      })
        .then((r) => r.json())
        .then(() => window.location.reload())
        .catch(() => input.form.submit());
    }, 500);
  });

  /* ---------- Collection sorting ---------- */
  document.querySelectorAll('[data-sort]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });


  /* ---------- Bundle bar (X achetés = 1 offert) ---------- */
  const bundleStrings = (bar) => {
    const el = bar.querySelector('[data-bundle-strings]');
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  };
  const renderBundle = (count) => {
    document.querySelectorAll('[data-bundle-bar]').forEach((bar) => {
      const size = parseInt(bar.dataset.size, 10) || 3;
      const s = bundleStrings(bar);
      const step = count % size;
      const free = Math.floor(count / size);
      const paidLeft = size - step - 1;
      const pct = count > 0 && step === 0 ? 100 : Math.round((step / size) * 100);
      const fill = bar.querySelector('[data-bundle-fill]');
      if (fill) fill.style.width = pct + '%';
      const msg = bar.querySelector('[data-bundle-msg]');
      if (msg) {
        let text;
        if (count > 0 && step === 0) {
          text = (free === 1 ? s.unlocked_one : s.unlocked_other || '').replace(/\d+/, free);
        } else if (paidLeft === 0) {
          text = s.next_free;
        } else {
          text = (paidLeft === 1 ? s.remaining_one : s.remaining_other || '').replace(/\d+/, paidLeft);
        }
        if (text) msg.textContent = text;
      }
      bar.querySelectorAll('[data-bundle-step]').forEach((li, i) => {
        const done = (count > 0 && step === 0) || i + 1 <= step;
        li.classList.toggle('is-done', done);
      });
    });
  };

  /* ---------- Discount code ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-discount-apply]');
    if (!b) return;
    const input = document.querySelector('[data-discount-input]');
    const code = input && input.value.trim();
    if (!code) { if (input) input.focus(); return; }
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(T.routes.cart || '/cart');
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) {
      e.preventDefault();
      const b = document.querySelector('[data-discount-apply]');
      if (b) b.click();
    }
  });

  /* ---------- Toast ---------- */
  const toast = document.getElementById('cart-toast');
  let toastTimer;
  const showToast = (msg) => {
    if (!toast) return;
    toast.innerHTML = '';
    const span = document.createElement('span');
    span.textContent = msg;
    const link = document.createElement('a');
    link.href = T.routes.cart || '/cart';
    link.textContent = '→';
    link.setAttribute('aria-label', 'Panier');
    toast.append(span, link);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 3200);
  };

  const refreshCount = () =>
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; });
        renderBundle(c.item_count);
        return c;
      })
      .catch(() => {});

  if (document.querySelector('[data-bundle-bar]')) refreshCount();
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCount(); });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-ajax-cart]');
    if (!form) return;
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-button]');
    if (btn) btn.disabled = true;
    fetch((T.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || data.message || 'Erreur');
        // Sur la page panier les lignes sont rendues côté serveur :
        // on recharge pour que le produit ajouté apparaisse vraiment.
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return null;
        }
        showToast(T.strings.added);
        return refreshCount();
      })
      .catch((err) => showToast(err.message))
      .finally(() => {
        if (btn && !document.body.classList.contains('template-cart')) btn.disabled = false;
      });
  });

  /* ---------- Product page variants ---------- */
  document.querySelectorAll('[data-product]').forEach((root) => {
    const jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    const form = root.querySelector('.product__form');
    if (!form) return;
    const idInput = form.querySelector('[data-variant-input]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const btn = form.querySelector('[data-add-button]');
    const mainImg = root.querySelector('[data-main-img]');
    const money = (cents) => {
      const fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2
      });
      return fmt.format(cents / 100);
    };
    const selected = () => Array.from(form.querySelectorAll('fieldset.option')).map((fs) => {
      const c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option]')) return;
      const opts = selected();
      const label = root.querySelector('[data-option-value="' + e.target.dataset.option + '"]');
      if (label) label.textContent = e.target.value;
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = T.strings.unavailable; }
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        compareEl.hidden = !(v.compare_at_price > v.price);
        if (v.compare_at_price) compareEl.textContent = money(v.compare_at_price);
      }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? (btn.dataset.label || btn.textContent.trim()) : T.strings.soldOut; }
      if (mainImg && v.featured_image && v.featured_image.src) {
        mainImg.removeAttribute('srcset');
        mainImg.src = v.featured_image.src + (v.featured_image.src.includes('?') ? '&' : '?') + 'width=1400';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
    if (btn && !btn.dataset.label) btn.dataset.label = T.strings.addToCart;

    root.querySelectorAll('[data-thumb]').forEach((t) => {
      t.addEventListener('click', () => {
        root.querySelectorAll('[data-thumb]').forEach((x) => x.classList.toggle('is-active', x === t));
        if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = t.dataset.src; }
      });
    });
  });
})();
